/**
 * Format a phone number for display using Dominica's +1-767 convention.
 * Returns the raw string as-is if it doesn't match the expected pattern,
 * so the tel: link still works with unusual input.
 */
export function formatDominicaPhone(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const digits = raw.replace(/\D/g, '');
  // Strip leading "1" (country code) before splitting.
  const local = digits.startsWith('1') ? digits.slice(1) : digits;
  if (local.length === 10 && local.startsWith('767')) {
    const a = local.slice(3, 6);
    const b = local.slice(6);
    return `+1-767-${a}-${b}`;
  }
  // Fall back to the raw string if the user typed something unusual.
  return raw;
}
